exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dps-manage {\n  margin-right: 10px; }\n  .dps-manage .subheader {\n    height: 40px; }\n    .dps-manage .subheader .title {\n      float: left;\n      font-size: 14px;\n      padding-right: 20px; }\n    .dps-manage .subheader .toolbar {\n      float: left;\n      border-left: 1px solid #CCC;\n      margin-left: 20px;\n      padding-left: 20px;\n      font-size: 12px; }\n  .dps-manage .btn-restore-points {\n    background-color: transparent;\n    color: #007cbb;\n    cursor: pointer; }\n  .dps-manage .btn-restore-points:hover {\n    background-color: transparent;\n    color: #004a70; }\n\n.dps-manage-tree {\n  overflow: scroll !important;\n  min-width: 256px;\n  line-height: 28px; }\n  .dps-manage-tree .tree {\n    width: auto !important;\n    max-width: none !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/dataprotection/dataprotection-vc/manage/dps-manage-vc.scss
// module id = g4vu
// module chunks = 0